import './contact.css';
import { useRef, useState } from "react";
import emailjs from '@emailjs/browser';
import ReactGA from 'react-ga4';
import logo from '../../img/your-logo.png';
import { content } from "../../content/landingContent";

const Contact = () => {
    const formRef = useRef();
    const [file, setFile] = useState(null); 
    const [name, setName] = useState(""); 
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");
    const [subject, setSubject] = useState(""); 
    const [showPopup, setShowPopup] = useState(false); 
    const [done, setDone] = useState(false)
    const { heading, body, button, success } = content.contact;

    // const handleFileChange = (e) => {
    //     const selectedFile = e.target.files[0];
    //     setFile(selectedFile);
    // };

    const handleSubmit = (e) => {
        e.preventDefault();
        
        ReactGA.event({
            category: 'Form',
            action: 'Submit',
            label: 'Contact Form Submission'
        });

        emailjs
        .sendForm(
          "service_241a5kq",
          "template_yb83pig",
          formRef.current,
          "5Ga8uKjz4P_65T7AS"
        )
        .then(
          (result) => {
            console.log(result.text);
            setDone(true)
          },
          (error) => {
            console.log(error.text);
          }
        );

        if (!name || !email) {
            alert("Name and Email are required fields.");
            return;
        }

        console.log("Selected File:", file);

        formRef.current.reset();
        setFile(null);
        setName("");
        setEmail("");
        setSubject("");
        setMessage("");
        setShowPopup(true); 
    };

    return (
        <section id="contact">
            <div className="contact-container">
                <div className="contact-left">
                    <div className="contact-logo-container">
                        <img src={logo} alt="Neonimble Logo" />
                    </div>
                    <div className="c-heading">
                        <h1>{heading}</h1>
                        <p>{body}</p>
                    </div>
                </div>

                <div className="contact-right">
                    <form ref={formRef} className='c-form' onSubmit={handleSubmit}>
                        <input
                            type="text"
                            placeholder="Your Name"
                            className="c-form-inputs"
                            value={name}
                            name="user_name"
                            onChange={(e) => setName(e.target.value)}
                            required 
                        />
                        <input
                            type="email"
                            placeholder="Your Email"
                            className="c-form-inputs"
                            value={email}
                            name="user_email"
                            onChange={(e) => setEmail(e.target.value)}
                            required 
                        />
                        <input
                            type="text"
                            placeholder="Subject"
                            className="c-form-inputs"
                            value={subject}
                            name="user_subject"
                            onChange={(e) => setSubject(e.target.value)}
                        />
                        <textarea
                            rows="5"
                            placeholder="Your Message"
                            className="c-form-message"
                            value={message}
                            name="message"
                            onChange={(e) => setMessage(e.target.value)}
                        />
                        {/* <input className="file-button" type="file" onChange={handleFileChange} /> */}
                        <button type="submit">{button}</button>
                        {done}
                    </form>
                </div>
            </div>

            {showPopup && (
                <div className="popup">
                    <p>{success}</p>
                    <button onClick={() => setShowPopup(false)}>Close</button>
                </div>
            )}
        </section>
    );
}

export default Contact;
